import { motion } from "framer-motion";

interface ProgressBarProps {
  /** 0–100 */
  value: number;
  /** Track balandligi (px). Figma: kartada 5, detail'da 6. */
  height?: number;
  animate?: boolean;
  className?: string;
}

/**
 * Progress bar — Figma §5.4. Track `var(--brand-progress-track)`,
 * fill `var(--brand-progress-fill)` (default qattiq orange, Click ko'k).
 */
export function ProgressBar({ value, height = 5, animate = true, className }: ProgressBarProps) {
  const width = Math.min(100, Math.max(0, value));
  return (
    <div
      className={className}
      style={{
        height,
        borderRadius: 999,
        overflow: "hidden",
        background: "var(--brand-progress-track, var(--c-line))",
      }}
    >
      <motion.div
        initial={animate ? { width: 0 } : false}
        animate={{ width: `${width}%` }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        style={{ height: "100%", borderRadius: 999, background: "var(--brand-progress-fill, var(--primary))" }}
      />
    </div>
  );
}
